export default __webpack_public_path__ + "static/media/nina-glas.92e3be0e.jpg";